import { Alert, Box, Text } from '@nimbus-ds/components';
import { useTranslationBilling } from 'domains/Billing';
import { NE_TYPE_OF_PAYMENT_PROMOTION } from '../constants';

function NECheckoutCommunication({
  type,
}: {
  type: NE_TYPE_OF_PAYMENT_PROMOTION;
}) {
  const t = useTranslationBilling('checkout.nuvemEnvioCheckoutCommunication');

  return (
    <Box data-testid="nuvem-envio-checkout-communication">
      <Alert appearance="success" title={t(`title${type}`)}>
        <Text>{t(`text${type}`)}</Text>
      </Alert>
    </Box>
  );
}

export default NECheckoutCommunication;
